<template>
	<div>
		<the-create :companyId="companyId" :productId="productId" :projectId="projectId" :editType="3" :read-published="read_only"></the-create>
	</div>
</template>

<script>
  import API from "@/../config/api.js";
	import TheCreate from "@/components/ProductComponents/TheCreate";
  import WindowMixin from "@/pages/redirectWindows/Mixins/WindowMixin";
	export default {
		components: {
      TheCreate,
		},
    mixins:[WindowMixin],
		data() {
			return {
				node: {},
        companyId: null,
        productId: null,
        projectId: null,
        read_only: false,
			}
		},
    async beforeMount(){

    },
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>
</style>
